import { makeStyles } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';
import { customTokens } from 'src/utils/theme';

export const useStyles = makeStyles({
  pointsSummaryContainer: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'flex-start' : 'center',
    width: '100%',
    flexWrap: 'wrap',
    gap: customTokens.spacingHorizontalMNudge,
  },
  totalPointsEarnedText: {
    fontSize: customTokens.fontSizeBase400,
    color: customTokens.colorNeutralForeground5,
    lineHeight: customTokens.lineHeightBase400,
    fontWeight: customTokens.fontWeightRegular,
    whiteSpace: 'nowrap',
  },
  earnedNextPointContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  earnedNextPointText: {
    fontSize: customTokens.fontSizeBase300,
    color: customTokens.colorNeutralForeground1,
    lineHeight: customTokens.lineHeightBase300,
  },
  starIcon: {
    color: customTokens.colorPaletteMarigoldForeground3,
    marginRight: customTokens.spacingHorizontalXS,
  },
});
